import ClientAgentExtender from '../../../Common/clientAgentExtender'
import ArrayHelper from '../../../Helpers/ArrayHelper'

export default class BlokadaKomercialnihSporocil extends ClientAgentExtender {
  _idPrikljucek = null
  _stevilka = null
  _blokirano = null
  _zgodovina = null
  _loading = false
  _trenutniPrikazZgodovine = []

  constructor (idPrikljucek, stevilka) {
    super()
    this._idPrikljucek = idPrikljucek
    this._stevilka = stevilka
  }

  async loadData (override = false) {
    if (this._blokirano === null || override) {
      let response = await this.ca.makeRequest(
        'prikljucek/telefonija/umts/komercialnaSporocila/info',
        {idPrikljucek: this._idPrikljucek, stevilka: this._stevilka},
        'GET'
      )
      this._blokirano = response.data.blokirano
      this._zgodovina = ArrayHelper.chunkArray(response.data.zgodovina.reverse(), 4)
      this.naloziTrenutnoPrikazanoZgodovino(1)
    }
  }

  async blokiraj () {
    this._loading = true
    await this.ca.makeRequest(
      'prikljucek/telefonija/umts/komercialnaSporocila/blokiraj',
      {idPrikljucek: this._idPrikljucek, stevilka: this._stevilka},
      'POST'
    )
    await this.loadData(true)
    this._loading = false
  }

  async deblokiraj () {
    this._loading = true
    await this.ca.makeRequest(
      'prikljucek/telefonija/umts/komercialnaSporocila/deblokiraj',
      {idPrikljucek: this._idPrikljucek, stevilka: this._stevilka},
      'POST'
    )
    await this.loadData(true)
    this._loading = false
  }

  naloziTrenutnoPrikazanoZgodovino (stran = 1) {
    this._trenutniPrikazZgodovine = this._zgodovina[stran - 1] || []
  }

  get blokirano () {
    return this._blokirano
  }

  set blokirano (value) {
    this._blokirano = value
  }

  get zgodovina () {
    return this._zgodovina
  }

  set zgodovina (value) {
    this._zgodovina = value
  }

  get loading () {
    return this._loading
  }

  set loading (value) {
    this._loading = value
  }

  get currentPage () {
    return this._currentPage
  }

  set currentPage (value) {
    this._currentPage = value
  }

  get trenutniPrikazZgodovine () {
    return this._trenutniPrikazZgodovine
  }

  set trenutniPrikazZgodovine (value) {
    this._trenutniPrikazZgodovine = value
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/Prikljucek/Telefonija/Umts/BlokadaKomercialnihSporocil.js